import { NgModule } from '@angular/core';
import {
  CybHeaderComponent,
  CybHeaderNavDirective,
  CybHeaderContentDirective,
  CybHeaderTitleDirective,
  CybHeaderLogoDirective
} from './header.component';

@NgModule({
  declarations: [
    CybHeaderComponent, CybHeaderNavDirective, CybHeaderContentDirective, CybHeaderTitleDirective,
    CybHeaderLogoDirective
  ],
  exports: [
    CybHeaderComponent, CybHeaderNavDirective, CybHeaderContentDirective, CybHeaderTitleDirective,
    CybHeaderLogoDirective
  ]
})

export class CybHeaderModule { }
